import { combineReducers } from '@reduxjs/toolkit';
import toastSlice from 'core/slices/toasts';
import projectsSlice from 'core/slices/projects';
import reportsMetaSlice from 'core/slices/reports';
import { apiSlice } from 'core/services/ApiSlice';
import pbiReportSlice from 'core/services/PBIReportService';
import { reportsApiSlice } from 'core/services/ReportsApiSlice';
import { gridReportsApiSlice } from 'core/services/GridReportsApiSlice';
import { bookmarksApiSlice } from 'core/services/BookmarkApiSlice';
import sidebarSlice from 'core/slices/sidebar';

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  [reportsApiSlice.reducerPath]: reportsApiSlice.reducer,
  [gridReportsApiSlice.reducerPath]: gridReportsApiSlice.reducer,
  [bookmarksApiSlice.reducerPath]: bookmarksApiSlice.reducer,
  toasts: toastSlice.reducer,
  pbiReportSlice: pbiReportSlice.reducer,
  projects: projectsSlice.reducer,
  reports: reportsMetaSlice.reducer,
  bookmarks: bookmarksApiSlice.reducer,
  sidebar: sidebarSlice.reducer,
});
export default rootReducer;
